import ShippingConstant from "../../constant/order/ShippingConstant";
import ShippingAction from "../../action/order/ShippingAction";
import ProductService from "../../../../../service/catalog/ProductService";
import StockService from "../../../../../service/catalog/StockService";
import OrderItemService from "../../../../../service/sales/order/OrderItemService";
import LocationService from "../../../../../service/LocationService";
import ProductTypeConstant from "../../../../../view/constant/ProductTypeConstant";
import CustomSaleConstant from "../../../../../view/constant/custom-sale/CustomSaleConstant";

/**
 * load product qty to order shipping
 *
 * @param action$
 * @returns {Observable<any>}
 */
export default function PrepareCreateShipmentEpic(action$) {
    return action$.ofType(ShippingConstant.ORDER_CREATE_SHIPMENT_LOAD_PRODUCT_QTYS_BEGIN)
        .mergeMap(async (action) => {
            const { order } = action;

            if (!order || !Array.isArray(order.items)) {
                return [ShippingAction.finishLoadProductQtys({}, null)];
            }

            let productQtys = {};
            let productIds = [];
            let prepareToShipProducts = {};
            let productMap = {};
            let bundleShipTogetherProducts = [];
            let associatedCustomer = order.customer_id || null; // Pegando o cliente associado

            order.items.forEach(item => {
                let productType = item.product_type;
                if (OrderItemService.getHasChildren(item, order)) {
                    if (
                        ProductTypeConstant.BUNDLE === productType &&
                        !OrderItemService.isShipSeparately(item, order)
                    ) {
                        bundleShipTogetherProducts.push({
                            item,
                            children: OrderItemService.getChildrenItems(item, order)
                        });
                    }
                    return;
                }

                productMap[item.product_id] = {
                    type: productType,
                    sku: item.sku,
                };
                productIds.push(item.product_id);

                if (!prepareToShipProducts.hasOwnProperty(item.product_id)) {
                    prepareToShipProducts[item.product_id] = 0;
                }

                prepareToShipProducts[item.product_id] += OrderItemService.getSimpleQtyToShip(item);
            });

            let stockList = await StockService.getStockProducts(productIds);
            productIds.forEach(productId => {
                if (!productMap[productId]) {
                    return;
                }

                if (productMap[productId].sku === CustomSaleConstant.SKU) {
                    productQtys[productId] = { isManageStock: false };
                    return;
                }

                if (!stockList.hasOwnProperty(productId)) {
                    productQtys[productId] = { isNotExisted: true };
                    return;
                }

                let fakeProduct = {
                    type_id: productMap[productId].type,
                    stocks: stockList[productId]
                };
                let productStockService = StockService.getProductStockService(fakeProduct);

                let qty = ProductService.getQty(fakeProduct) || 0;

                if (
                    order.pos_location_id === LocationService.getCurrentLocationId() &&
                    !productStockService.getBackorders(fakeProduct)
                ) {
                    qty += prepareToShipProducts[productId];
                }

                productQtys[productId] = {
                    isManageStock: productStockService.isManageStock(fakeProduct),
                    qty,
                    stockInLocation: productStockService.getQtyInLocation(fakeProduct)
                };
            });

            if (!bundleShipTogetherProducts.length) {
                return ShippingAction.finishLoadProductQtys(productQtys, associatedCustomer);
            }

            bundleShipTogetherProducts.forEach(bundleProduct => {
                let qtyToShip = OrderItemService.getQtyToShip(bundleProduct.item);

                let childIsNotExisted = bundleProduct.children.find(child => 
                    productQtys[child.product_id] && productQtys[child.product_id].isNotExisted
                );

                if (childIsNotExisted) {
                    productQtys[bundleProduct.item.product_id] = { qty: 0 };
                    return;
                }

                let childrenManageStock = bundleProduct.children.find(child => 
                    productQtys[child.product_id] && productQtys[child.product_id].isManageStock
                );

                if (!childrenManageStock) {
                    productQtys[bundleProduct.item.product_id] = { qty: qtyToShip };
                    return;
                }

                let childrenNotEnoughToFullShip = bundleProduct.children.filter(child => {
                    if (!productQtys[child.product_id] || !productQtys[child.product_id].isManageStock) {
                        return false;
                    }
                    if (productQtys[child.product_id].qty === false) {
                        return true;
                    }

                    let childQtyToShip = OrderItemService.getSimpleQtyToShip(child);
                    return productQtys[child.product_id].qty < childQtyToShip;
                });

                if (childrenNotEnoughToFullShip.length) {
                    let qtys = childrenNotEnoughToFullShip.map(child =>
                        Math.floor(productQtys[child.product_id].qty / qtyToShip)
                    );

                    productQtys[bundleProduct.item.product_id] = { qty: Math.max(Math.min(...qtys), 0) };
                    return;
                }

                productQtys[bundleProduct.item.product_id] = { qty: qtyToShip };
            });

            return ShippingAction.finishLoadProductQtys(productQtys, associatedCustomer);
        })
        .catch(error => {
            console.log("❌ Erro no PrepareCreateShipmentEpic:", error);
        });
}



// WEBPACK FOOTER //
// ./src/extension/take-shipment/view/epic/order/PrepareCreateShipmentEpic.js